<template>
    <div class="">
        <el-table :data="Twlist" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40" :selectable="checkSelectable"></el-table-column>
            <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip
                width="100"></el-table-column>
            <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip
                width="150"></el-table-column>
            <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip min-width="350">
                <template v-slot="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.Goods_Product_Img" alt="" style="width: 40px; height: auto; object-fit: contain; margin-right: 5px">
                        <span>{{ scope.row.Goods_Product_Name }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="Goods_Product_Spec" label="规格" align="center"
                show-overflow-tooltip></el-table-column>
            <el-table-column prop="Goods_IsInsale" label="已下架" align="center" width="80"></el-table-column>
            <el-table-column prop="IsOffer" label="是否仅报价使用" align="center" v-if="TradeType == 2"
                width="150"></el-table-column>
            <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="120">
                <template v-slot="scope">
                    <div class="moneyRed">￥{{ scope.row.Goods_Product_Price }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="prop" label="数量" align="center" width="150">
                <template v-slot="scope">
                    <div v-if="scope.row.GoodsAmountState == 'true'">
                        <el-input-number v-model="scope.row.Goods_Amount" :min="1" :max="9999999"
                            @change="changeMethods(scope.row)"></el-input-number>
                    </div>
                    <div v-else>x {{ scope.row.Goods_Amount }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="Remaining_Amount" label="剩余可用数量" align="center" v-if="TradeType == 1" width="120">
                <template slot="header">
                    <span class="flex-content-center">
                        剩余可用数量
                        <el-popover placement="top-start" title="" trigger="hover" content="仅统计现场部分">
                            <span slot="reference" class="flex-content-center"><img src="@/assets/images/wenh.png"
                                    alt="" style="width: 15px; height: 15px; margin-left: 2px" /></span>
                        </el-popover>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="Remaining_Amount" label="合计" align="center" width="150">
                <template v-slot="scope">
                    <div class="moneyRed">￥{{ scope.row.Goods_TotalPrice }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="prop" label="操作" align="center" width="100">
                <template v-slot="scope">
                    <div v-if="scope.row.DelState == 'true'" style="cursor: pointer"
                        @click="deleteChoose(scope.row.Goods_ID)">删除</div>
                </template>
            </el-table-column>
        </el-table>
        <div class="cartTableBottom">
            合计：
            <span class="moneyRed">￥{{ allCartPrice }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShoppingCart',
    props: {
        Twlist: {
            type: Array,
            default: []
        },
        TradeType: {
            type: Number,
            default: 0
        },
        allCartPrice: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            operationShow: false
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        deleteChoose(e) {
            this.$emit('delete', [e]);
        },
        changeMethods(e) {
            this.$emit('change', e);
        },
        handleSelectionChange(val) {
            this.$emit('selectionChange', val);
        },
        checkSelectable(row) {
            return row.DelState == 'true' ? true : false;
        }
    }
};
</script>
<style  scoped>
.moneyRed {
    font-weight: 700;
    color: red;
}
.cartTableBottom {
    padding: 10px;
    border: 1px #dfe6ec solid;
    border-top: 0px;
}
</style>
